import {styles} from "../../stylesheets/simulateurs.css";
import ButtonYesno from "../buttons/button.yesno";
import React from "react";

const CaisseEpargneQuestion = (props) => {

    return (
        <div>
            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                    S'agit-il d'un prêt Caisse d'Epargne ?
                </div>
                <div>
                    <ButtonYesno handleChange={props.handleChange} setter={props.setCaisseEpargne} reduxKey={"caisse_epargne"} defaultValue={0}/>
                </div>
            </div>
        </div>
    );
};

export default CaisseEpargneQuestion;
